// extracted by mini-css-extract-plugin
export default {"childrenClass":"AcademicRecords__childrenClass___CFyNV"};